import { toast } from 'react-toastify';
import Service from '../../lib/Service';
import { blogActions } from '../ActionTypes';


export const fetchBlog = () => async (dispatch) => {
  try {
    dispatch({
      type: blogActions.BLOG_FETCH_START
    });
    const resData = await Service.GET({
      name: 'blog',
      queryString: ''
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(res.message);
    });
    dispatch({
      type: blogActions.BLOG_FETCH_SUCCESS,
      payload: resData
    });
  } catch (error) {
    dispatch({
      type: blogActions.BLOG_FETCH_FAILED,
      payload: { error: error.message }
    });
  }
};
export const saveBlog = (formData) => async (dispatch) => {
  try {
    const payload = {
      ...formData,
      OrderNumber: formData.OrderNumber ? Number(formData.OrderNumber) : 0
    };

    dispatch({
      type: blogActions.BLOG_SAVE_START
    });
    await Service[formData.Id === '0' ? 'POST' : 'PUT']({
      name: 'blog',
      payload
    }).then((res) => {
      if (res.success) {
        return res.data;
      }
      throw new Error(toast.error(res.message));
    });
    dispatch({
      type: blogActions.BLOG_SAVE_SUCCESS
    });
    toast.success('Saved Successfully');
    setTimeout(() => { window.location.href = '/blog'; }, 1000);
  } catch (error) {
    dispatch({
      type: blogActions.BLOG_SAVE_FAILED,
      payload: { formError: error.message }
    });
  }
};

export const editBlog = (blogId) => async (dispatch, getState) => {
  try {
    const { blogList } = getState().blog;
    const data = blogList.find((item) => item.Id === blogId);
    if (!data) {
      throw new Error('Something went wrong');
    }
    dispatch({
      type: blogActions.BLOG_SET_FORM,
      payload: { form: data }
    });
  } catch (error) {
    toast.error(error.message);
  }
};

export const resetForm = () => (dispatch) => dispatch({ type: blogActions.BLOG_RESET_FORM });

export const deleteBlog = (Id) => async (dispatch) => Service.DELETE({
  name: 'blog',
  payload: { Id }
}).then((res) => {
  if (res.success) {
    dispatch(fetchBlog());
    return true;
  }
  throw new Error(res.message);
});
